import { type IWizardStep } from "interfaces";
import { type FC, type ReactElement, useEffect } from "react";
import { RolePermissions, type UsersGroupsContext } from "../../../../enums";
import PeopleWrapper from "../../PeopleAssignments/Overview/PeopleWrapper/PeopleWrapper";
import GroupsOverview from "./GroupsOverview";
import UsersOverview from "./UsersOverview";

interface EditPeopleProps extends IWizardStep {
  scormId: number;
  usersGroupsContext: UsersGroupsContext;
  onContextChanged: (value: UsersGroupsContext) => void;
}

export const EditPeople: FC<EditPeopleProps> = ({ scormId, usersGroupsContext, acceptHandlers, onContextChanged }) => {
  useEffect(() => {
    acceptHandlers?.({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PeopleWrapper
        permission={RolePermissions.AssetsManage}
        usersGroupsContext={usersGroupsContext}
        onContextChanged={onContextChanged}
        renderGroupsOverview={(customHeaderContent: ReactElement) => (
          <GroupsOverview scormId={scormId} customHeaderContent={customHeaderContent} />
        )}
        renderUsersOverview={(customHeaderContent: ReactElement) => (
          <UsersOverview scormId={scormId} customHeaderContent={customHeaderContent} />
        )}
      />
    </>
  );
};

export default EditPeople;
